export const colors = {
  background:{
      lightGrey:'#fafafa',
      red:'#D91A46'
  },
  border:{
      lime:'1px solid rgba(138,138,138,.15)'
  }
}